import styled from 'styled-components';

export const UserFilter = styled.div``;
